const state = {
  loading: false,
  chartData: {
    origin: 560,
    onTheWay: 300,
    destination: 260,
  },
  series: [83],
};

const getters = {
  compleated: (state) => () => {
    const origin = state.chartData.origin;
    const destination = state.chartData.destination;
    const percentage = (destination * 100) / origin;
    return [Math.round(percentage)];
  },
  uncompleated: (state) => () => {
    const origin = state.chartData.origin;
    const destination = state.chartData.destination;
    const percentage = ((origin - destination) * 100) / origin;
    return [Math.round(percentage)];
  }
};

const actions = {
  // action
};

const mutations = {
  // mutations
};

export default {
  state,
  getters,
  actions,
  mutations,
};
